(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-before-after]').forEach((frame) => {
    const clip = frame.querySelector('[data-before-after-clip]');
    const handle = frame.querySelector('[data-before-after-handle]');
    if (!clip || !handle) return;

    function setPosition(percent) {
      const clamped = Math.min(100, Math.max(0, percent));
      clip.style.clipPath = `inset(0 ${100 - clamped}% 0 0)`;
      handle.style.left = clamped + '%';
    }

    function updateFromEvent(event) {
      const rect = frame.getBoundingClientRect();
      const percent = ((event.clientX - rect.left) / rect.width) * 100;
      setPosition(percent);
    }

    let dragging = false;

    // Pointer events (not separate mouse/touch handlers) so mouse-drag on
    // desktop and touch-drag on mobile share this exact same code path.
    frame.addEventListener('pointerdown', (event) => {
      // Without this, a real press-and-move gesture starting on one of
      // the <img> elements crosses the browser's native drag-and-drop
      // threshold after a few pixels of movement — the browser hijacks
      // the gesture into a native image drag, which fires pointercancel
      // on the pointer sequence we're tracking (setting dragging back to
      // false almost immediately). That's why a single click/tap always
      // worked (no movement, so the native drag threshold never
      // triggers) while an actual hold-and-move drag went nowhere.
      // draggable="false" on both <img> tags (see the Liquid above)
      // disables that native behavior at the source; preventDefault
      // here is a second line of defense against any other native
      // gesture (text selection, etc.) trying to take over mid-drag.
      event.preventDefault();
      dragging = true;
      frame.setPointerCapture(event.pointerId);
      updateFromEvent(event);
    });
    frame.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      updateFromEvent(event);
    });
    frame.addEventListener('pointerup', (event) => {
      dragging = false;
      frame.releasePointerCapture(event.pointerId);
    });
    frame.addEventListener('pointercancel', () => {
      dragging = false;
    });

    setPosition(50);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const form = document.querySelector('[data-cart-form]');
    if (!form) return;

    function updateShippingBar(cart) {
      const wrapper = document.querySelector('[data-shipping-progress]');
      if (!wrapper) return;
      const thresholdCents = Number(wrapper.dataset.threshold || 0);
      if (!thresholdCents) return;

      const remaining = Math.max(thresholdCents - cart.total_price, 0);
      const percent = Math.min((cart.total_price / thresholdCents) * 100, 100);
      const fill = wrapper.querySelector('[data-shipping-fill]');
      const text = wrapper.querySelector('[data-shipping-text]');
      if (fill) fill.style.width = percent + '%';
      if (text) {
        if (remaining > 0) {
          text.textContent = wrapper.dataset.template.replace('{amount}', formatMoney(remaining));
          text.classList.remove('cart-footer__shipping-text--met');
        } else {
          text.textContent = wrapper.dataset.metText;
          text.classList.add('cart-footer__shipping-text--met');
        }
      }
    }

    function formatMoney(cents) {
      // Matches the store's money_format ("€1.234,56") rather than relying on
      // Intl/browser locale, which produced a different decimal separator
      // than the server-rendered amounts.
      const amount = (cents / 100).toFixed(2);
      const [whole, decimals] = amount.split('.');
      const wholeWithDots = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return '€' + wholeWithDots + ',' + decimals;
    }

    async function changeLine(key, quantity) {
      const variantId = key.split(':')[0];
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity }),
      });
      const cart = await response.json();

      if (!response.ok || !cart.items) {
        console.error('Cart update failed', response.status, cart);
        return;
      }

      if (cart.item_count === 0) {
        window.location.reload();
        return;
      }

      const row = form.querySelector('[data-cart-key="' + key + '"]');
      // Match by variant id rather than the full key: Shopify regenerates the
      // properties-hash portion of item.key on every mutation on this store,
      // so comparing the full key against the one we sent would always miss.
      const updatedItem = cart.items.find((item) => item.key.split(':')[0] === variantId);

      if (quantity === 0 || !updatedItem) {
        row?.remove();
      } else if (row) {
        row.dataset.cartKey = updatedItem.key;
        const lineTotal = row.querySelector('[data-line-total]');
        const input = row.querySelector('[data-quantity-input]');
        if (lineTotal) lineTotal.textContent = formatMoney(updatedItem.final_line_price);
        if (input) input.value = updatedItem.quantity;
      }

      const subtotal = form.querySelector('[data-cart-subtotal]');
      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

      updateShippingBar(cart);
    }

    form.addEventListener('click', (event) => {
      const row = event.target.closest('[data-cart-item]');
      if (!row) return;
      const key = row.dataset.cartKey;
      const input = row.querySelector('[data-quantity-input]');

      if (event.target.closest('[data-quantity-increase]')) {
        event.preventDefault();
        changeLine(key, Number(input.value) + 1);
      } else if (event.target.closest('[data-quantity-decrease]')) {
        event.preventDefault();
        const next = Math.max(Number(input.value) - 1, 0);
        changeLine(key, next);
      } else if (event.target.closest('[data-cart-remove]')) {
        event.preventDefault();
        changeLine(key, 0);
      }
    });

    form.addEventListener('change', (event) => {
      if (!event.target.matches('[data-quantity-input]')) return;
      const row = event.target.closest('[data-cart-item]');
      const key = row?.dataset.cartKey;
      const quantity = Math.max(Number(event.target.value) || 0, 0);
      if (key) changeLine(key, quantity);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-usp-bar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.usp-bar').forEach((root) => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    const viewport = root.querySelector('[data-usp-viewport]');
    const track = root.querySelector('[data-usp-track]');
    const dotsContainer = root.querySelector('[data-usp-dots]');
    if (!viewport || !track || !dotsContainer) return;

    const slides = Array.from(track.children);
    if (slides.length < 2) return;

    const prevButton = root.querySelector('[data-usp-prev]');
    const nextButton = root.querySelector('[data-usp-next]');
    if (prevButton) prevButton.style.display = 'flex';
    if (nextButton) nextButton.style.display = 'flex';

    slides.forEach((slide, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'usp-bar__dot';
      dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
      dot.addEventListener('click', () => goToSlide(index));
      dotsContainer.appendChild(dot);
    });
    const dots = Array.from(dotsContainer.children);

    function scrollToSlide(slide) {
      viewport.scrollLeft = slide.offsetLeft - (viewport.clientWidth - slide.offsetWidth) / 2;
    }

    function updateActiveDot() {
      const viewportRect = viewport.getBoundingClientRect();
      const viewportCenter = viewportRect.left + viewportRect.width / 2;
      let closestIndex = 0;
      let closestDistance = Infinity;
      slides.forEach((slide, index) => {
        const rect = slide.getBoundingClientRect();
        const distance = Math.abs(rect.left + rect.width / 2 - viewportCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });
      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === closestIndex));
      return closestIndex;
    }

    // Guards the auto-advance's own programmatic scroll so the scroll
    // listener below doesn't mistake it for manual interaction and reset
    // its own timer.
    let isProgrammaticScroll = false;

    function goToSlide(index) {
      isProgrammaticScroll = true;
      scrollToSlide(slides[index]);
      window.setTimeout(() => {
        isProgrammaticScroll = false;
      }, 500);
    }

    prevButton?.addEventListener('click', () => {
      const currentIndex = updateActiveDot();
      goToSlide((currentIndex - 1 + slides.length) % slides.length);
    });
    nextButton?.addEventListener('click', () => {
      const currentIndex = updateActiveDot();
      goToSlide((currentIndex + 1) % slides.length);
    });

    let autoAdvanceTimer;
    function startAutoAdvance() {
      clearInterval(autoAdvanceTimer);
      autoAdvanceTimer = setInterval(() => {
        const currentIndex = updateActiveDot();
        goToSlide((currentIndex + 1) % slides.length);
      }, 5000);
    }

    viewport.addEventListener(
      'scroll',
      () => {
        updateActiveDot();
        if (isProgrammaticScroll) return;
        startAutoAdvance();
      },
      { passive: true }
    );

    updateActiveDot();
    startAutoAdvance();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  // Only handles the prev/next button clicks — the swipe/drag gesture
  // itself is native browser behavior from overflow-x: auto combined
  // with scroll-snap-type on the track (see the mobile media query in
  // the stylesheet above), same as sections/ugc-carousel.liquid.
  document.querySelectorAll('[data-featured-products-track]').forEach((track) => {
    const section = track.closest('.featured-products');
    if (!section) return;

    const prevButton = section.querySelector('[data-featured-products-prev]');
    const nextButton = section.querySelector('[data-featured-products-next]');

    function scrollByOneCard(direction) {
      const card = track.querySelector('.featured-products__card');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      const step = card.getBoundingClientRect().width + gap;
      track.scrollLeft += direction * step;
    }

    prevButton?.addEventListener('click', () => scrollByOneCard(-1));
    nextButton?.addEventListener('click', () => scrollByOneCard(1));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderDrawer extends HTMLElement {
    constructor() {
      super();

      this.toggle = this.querySelector('.header__drawer-toggle');
      this.closeButton = this.querySelector('.header__drawer-close');
      this.backdrop = this.querySelector('.header__drawer-backdrop');

      this.toggle.addEventListener('click', () => this.open());
      this.closeButton.addEventListener('click', () => this.close());
      this.backdrop.addEventListener('click', () => this.close());
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
      });
    }

    open() {
      this.classList.add('is-open');
      this.toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      this.closeButton.focus();
    }

    close() {
      this.classList.remove('is-open');
      this.toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      this.toggle.focus();
    }
  }

  customElements.define('header-drawer', HeaderDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-list-collections"] && !Shopify.designMode) return;
  try {
    
  // Infinite-loop mobile carousel. The swipe/drag gesture itself is
  // native overflow-x: auto + scroll-snap-type behavior (see the mobile
  // media query in the stylesheet above) — this only does two things:
  // (1) starts the scroll position on the first real tile, skipping past
  // the prepended clone tiles, and (2) after scrolling settles, silently
  // (no animation) snaps back from a cloned region to the equivalent real
  // tile, so it reads as an endless loop with no visible jump.
  document.querySelectorAll('[data-list-collections-track]').forEach((track) => {
    const section = track.closest('.list-collections');
    if (!section) return;

    const realCount = parseInt(track.dataset.realCount, 10);
    const cloneCount = parseInt(track.dataset.cloneCount, 10);
    const prevButton = section.querySelector('[data-list-collections-prev]');
    const nextButton = section.querySelector('[data-list-collections-next]');

    function getStep() {
      const item = track.querySelector('.collection-tile');
      if (!item) return 0;
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    function scrollByStep(direction) {
      const step = getStep();
      if (!step) return;
      // Direct scrollLeft assignment, not scrollBy()/scrollTo() with smooth
      // behavior — combined with scroll-snap-type, smooth programmatic
      // scrolling does not reliably animate in every browser (same
      // reasoning as sections/ugc-carousel.liquid and the product media
      // gallery's own prev/next buttons).
      track.scrollLeft += direction * step;
    }

    if (!realCount || !cloneCount) {
      // Nothing to loop (too few collections to need it) — buttons still
      // page through the plain scroll-snap track.
      prevButton?.addEventListener('click', () => scrollByStep(-1));
      nextButton?.addEventListener('click', () => scrollByStep(1));
      return;
    }

    function jumpTo(index) {
      const step = getStep();
      track.scrollTo({ left: step * index, behavior: 'auto' });
    }

    jumpTo(cloneCount);

    let settleTimeout;
    track.addEventListener(
      'scroll',
      () => {
        clearTimeout(settleTimeout);
        settleTimeout = setTimeout(() => {
          const step = getStep();
          if (!step) return;
          const index = Math.round(track.scrollLeft / step);
          if (index >= cloneCount + realCount) {
            jumpTo(index - realCount);
          } else if (index < cloneCount) {
            jumpTo(index + realCount);
          }
        }, 120);
      },
      { passive: true }
    );

    prevButton?.addEventListener('click', () => scrollByStep(-1));
    nextButton?.addEventListener('click', () => scrollByStep(1));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-showcase"] && !Shopify.designMode) return;
  try {
    
  // Only handles the prev/next button clicks — the swipe/drag gesture
  // itself is native browser behavior from overflow-x: auto combined
  // with scroll-snap-type on the track (see the mobile media query in
  // the stylesheet above). Identical technique to
  // sections/featured-products.liquid's carousel, including the direct
  // scrollLeft assignment instead of scrollBy()/scrollTo() with smooth
  // behavior, which doesn't reliably animate in every browser once
  // scroll-snap-type is involved.
  document.querySelectorAll('[data-product-showcase-track]').forEach((track) => {
    const section = track.closest('.product-showcase');
    if (!section) return;

    const prevButton = section.querySelector('[data-product-showcase-prev]');
    const nextButton = section.querySelector('[data-product-showcase-next]');

    function scrollByOneCard(direction) {
      const card = track.querySelector('.product-showcase__card');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      const step = card.getBoundingClientRect().width + gap;
      track.scrollLeft += direction * step;
    }

    prevButton?.addEventListener('click', () => scrollByOneCard(-1));
    nextButton?.addEventListener('click', () => scrollByOneCard(1));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  function getCarouselParts(root) {
    return {
      viewport: root.querySelector('[data-carousel-viewport]'),
      slides: Array.from(root.querySelectorAll('[data-carousel-slide]')),
      dots: Array.from(root.querySelectorAll('[data-carousel-dot]')),
    };
  }

  function scrollToSlide(viewport, slide) {
    if (!viewport || !slide) return;
    // A plain scrollLeft assignment is used instead of scrollIntoView()/scrollTo()
    // with smooth behavior: combined with scroll-snap-type, smooth programmatic
    // scrolling does not reliably animate the container in every browser.
    viewport.scrollLeft = slide.offsetLeft - (viewport.clientWidth - slide.offsetWidth) / 2;
  }

  function updateActiveSlide(root) {
    const { viewport, slides, dots } = getCarouselParts(root);
    if (!viewport || !slides.length) return;

    const viewportRect = viewport.getBoundingClientRect();
    const viewportCenter = viewportRect.left + viewportRect.width / 2;

    let closestSlide = slides[0];
    let closestDistance = Infinity;
    slides.forEach((slide) => {
      const rect = slide.getBoundingClientRect();
      const slideCenter = rect.left + rect.width / 2;
      const distance = Math.abs(slideCenter - viewportCenter);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestSlide = slide;
      }
    });

    const activeIndex = slides.indexOf(closestSlide);
    slides.forEach((slide, index) => {
      slide.classList.toggle('is-active', index === activeIndex);
    });
    dots.forEach((dot, index) => {
      dot.classList.toggle('is-active', index === activeIndex);
    });
  }

  document.querySelectorAll('.reviews-carousel').forEach((root) => {
    const { viewport, slides } = getCarouselParts(root);
    if (!viewport || !slides.length) return;

    updateActiveSlide(root);

    // rAF-gated: touch-scroll can fire the 'scroll' event far more than
    // once per frame (measured well over 60 times/sec on some devices),
    // and each call was doing a getBoundingClientRect() read per slide —
    // a forced-layout cost that was showing up directly in Total Blocking
    // Time. Coalescing to at most one update per animation frame keeps
    // the highlight visually live while cutting the actual call count by
    // an order of magnitude. A previous version ran this uncoalesced on
    // every scroll event specifically to avoid rAF's other failure mode —
    // it's fully suspended on hidden/background tabs, so a scroll that
    // straddles the tab being backgrounded could leave the highlight
    // stuck on a stale slide. The visibilitychange listener below is the
    // fix for that specific case: it forces one final sync as soon as the
    // tab is visible again, so the rAF gate no longer needs trading away.
    let scheduled = false;
    function scheduleUpdate() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        updateActiveSlide(root);
      });
    }

    viewport.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') updateActiveSlide(root);
    });

    const prevButton = root.querySelector('[data-carousel-prev]');
    const nextButton = root.querySelector('[data-carousel-next]');
    if (prevButton) {
      prevButton.addEventListener('click', () => {
        const activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
        const targetIndex = Math.max(activeIndex - 1, 0);
        scrollToSlide(viewport, slides[targetIndex]);
      });
    }
    if (nextButton) {
      nextButton.addEventListener('click', () => {
        const activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
        const targetIndex = Math.min(activeIndex + 1, slides.length - 1);
        scrollToSlide(viewport, slides[targetIndex]);
      });
    }

    root.querySelectorAll('[data-carousel-dot]').forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number(dot.getAttribute('data-index'));
        scrollToSlide(viewport, slides[index]);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-carousel"] && !Shopify.designMode) return;
  try {
    
  // Shared by both the prev/next arrows and the dots below, so they can
  // never drift out of sync with each other: reads the item's real
  // rendered width and divides it into the track's own width to get how
  // many items are actually showing at once — 1 on mobile, 3 on desktop
  // (see the min-width: 1024px block in the stylesheet) — instead of a
  // hardcoded per-breakpoint step, so this keeps working correctly at any
  // width in between without a separate desktop/mobile branch.
  function ugcGetStepMetrics(track) {
    const item = track.querySelector('.ugc-carousel__item');
    if (!item) return null;
    const itemWidth = item.getBoundingClientRect().width;
    const gap = parseFloat(getComputedStyle(track).gap) || 0;
    const step = itemWidth + gap;
    const itemsPerView = Math.max(1, Math.round(track.clientWidth / step));
    return { step, itemsPerView };
  }

  function ugcScrollByPage(track, direction) {
    const metrics = ugcGetStepMetrics(track);
    if (!metrics) return;
    // A plain scrollLeft assignment, not scrollBy()/scrollTo() with smooth
    // behavior: combined with scroll-snap-type, smooth programmatic
    // scrolling does not reliably animate the container in every browser
    // (same reasoning as the product media gallery's setActiveMedia above).
    track.scrollLeft += direction * metrics.itemsPerView * metrics.step;
  }

  // Rebuilds the dot row for the current items-per-view (called on init
  // and on resize, since itemsPerView flips at the 1024px breakpoint) and
  // keeps the active dot in sync with manual swipe/scroll, not just
  // arrow clicks.
  function ugcSetupDots(carousel) {
    const track = carousel.querySelector('[data-ugc-track]');
    const dotsContainer = carousel.querySelector('[data-ugc-dots]');
    if (!track || !dotsContainer) return;

    const itemCount = track.querySelectorAll('.ugc-carousel__item').length;
    const labelTemplate = dotsContainer.dataset.ugcDotLabel || '%d';
    let metrics = null;
    let pageCount = 0;

    function updateActiveDot() {
      if (!metrics || pageCount < 2) return;
      const currentPage = Math.round(track.scrollLeft / (metrics.itemsPerView * metrics.step));
      dotsContainer.querySelectorAll('.ugc-carousel__dot').forEach((dot, index) => {
        dot.classList.toggle('is-active', index === currentPage);
      });
    }

    function rebuild() {
      metrics = ugcGetStepMetrics(track);
      if (!metrics) return;
      const newPageCount = Math.max(1, Math.ceil(itemCount / metrics.itemsPerView));
      if (newPageCount === pageCount) {
        updateActiveDot();
        return;
      }
      pageCount = newPageCount;
      dotsContainer.innerHTML = '';
      if (pageCount < 2) return;
      for (let page = 0; page < pageCount; page += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ugc-carousel__dot';
        dot.setAttribute('aria-label', labelTemplate.replace('%d', page + 1));
        dot.addEventListener('click', () => {
          track.scrollLeft = page * metrics.itemsPerView * metrics.step;
        });
        dotsContainer.appendChild(dot);
      }
      updateActiveDot();
    }

    rebuild();
    track.addEventListener('scroll', updateActiveDot, { passive: true });

    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(rebuild, 150);
    });
  }

  document.querySelectorAll('.ugc-carousel').forEach((carousel) => {
    const track = carousel.querySelector('[data-ugc-track]');
    const prevButton = carousel.querySelector('[data-ugc-prev]');
    const nextButton = carousel.querySelector('[data-ugc-next]');

    if (track && prevButton) prevButton.addEventListener('click', () => ugcScrollByPage(track, -1));
    if (track && nextButton) nextButton.addEventListener('click', () => ugcScrollByPage(track, 1));

    ugcSetupDots(carousel);
  });

  } catch(e) { console.error(e); }
})();
})();
